/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

/** Custom Hooks */
import useDebounce from '../../../app/customHooks/useDebounce';

/** Utilities */
import { encryptUrlData } from '../../../services/CryptoService';

/** Common Components */
import MolGrid from '../../../components/grid/MolGrid';
import CardSection from '../../../components/ui/card/CardSection';

/** Configuration Files */
import { reviewTimesheetGridConfig } from './config/reviewTimesheetGridConfig.data';

/** RTK Query */
import { useGetTimeSheetByReviewUserIdMutation } from '../../../app/services/timeSheetLogAPI';

/** SCSS **/
import "./ReviewTimesheet.scss";

const ReviewTimesheet = () => {

  const molGridRef = useRef();

  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState(null);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const debouncedSearch = useDebounce(searchText, 300);

  const { user } = useSelector((state) => state.auth);
  const userID = user.userId;

  const [getTimeSheetByReviewUserId, {
    isLoading: isTimeSheetLoading,
    isSuccess: isTimeSheetSuccess,
    data: timeSheetData,
  }] = useGetTimeSheetByReviewUserIdMutation();

  const getReviewTimeSheet = (pageObject, searchText) => {
    const req = {
      pagination: { pageNumber: pageObject.pageNumber, pageSize: pageObject.pageSize },
      filters: { searchText: debouncedSearch },
      userId: userID
    }
    getTimeSheetByReviewUserId(req);
  }

  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  }

  const handlePageChange = (pageObject) => {
    setCurrentPage(pageObject.pageNumber || pageObject);
    setPageSize(pageObject.pageSize || 10)
    getReviewTimeSheet(pageObject, debouncedSearch);
  }

  const handleEditClick = (data) => {
    let userId = data.userId;
    let userName = data.name;
    if (userId) {
      const navigationUrl = `/TimeSheet/ReviewTimeSheet/Employee/${encryptUrlData({ userId: userId, name: userName })}`;
      window.open(navigationUrl, "_blank", "noopener,noreferrer");
    }
  }

  useEffect(() => {
    if (molGridRef.current) {
      getReviewTimeSheet(molGridRef.current.getDefulatPageObject(), debouncedSearch);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (isTimeSheetSuccess && timeSheetData) {
      if (timeSheetData.dataSource) {
        setDataSource(timeSheetData.dataSource)
      }
      if (timeSheetData.totalRecord) {
        setTotalRowCount(timeSheetData.totalRecord)
      }
    }
  }, [isTimeSheetSuccess, timeSheetData]);

  const actionHandler = {
    EDIT: handleEditClick
  }

  return (
    <div className="timesheet-list center-top-space">
      <div className="list-view-section">
        <div className="table-grid">
          <CardSection
            isContentLoading={isTimeSheetLoading}
            cardTitle={"Review Time Sheet"}
            rightButton={false}
            handleChange={handleOnSearchChange}
            searchInputName="Search Time Sheet"
            searchInput={true}
            isShorting={true}
          >
            <MolGrid
              ref={molGridRef}
              configuration={reviewTimesheetGridConfig}
              dataSource={dataSource}
              allowPagination={true}
              pagination={{
                totalCount: totalRowCount,
                pageSize: pageSize,
                currentPage: currentPage,
              }}
              isLoading={isTimeSheetLoading}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
          </CardSection>
        </div>
      </div>
    </div>
  )
}

export default ReviewTimesheet